/* eslint-disable @next/next/no-img-element */

'use client'

import React from 'react'
import { useElementVisible } from '@hooks/useElementVisible'
import { NewsMock } from '@components/AboutUs/AboutUsMock'
import styles from './NewsSection.module.scss'
import { NewsCard } from './NewsCard'

const NewsSection = () => {
  const headerSection = useElementVisible({ threshold: 1 })
  return (
    <div className={styles.newsContainer}>
      <div
        ref={headerSection.ref}
        className={`${styles.newsContainerHeading} ${headerSection.isVisible ? styles.visible : ''}`}>
        <p className={styles.newsContainerHeading1}>{NewsMock?.title}</p>
        <p className={styles.newsContainerHeading2}>{NewsMock?.description}</p>
      </div>
      <div className={styles.newsCardContainer}>
        <div className={styles.line} />
        {NewsMock?.newsData?.map((news, i) => (
          <>
            <NewsCard news={news} key={i} />
            <div className={styles.line} />
          </>
        ))}
      </div>
    </div>
  )
}

export default NewsSection
